<script>

export default{
    methods: {
        enter(el) {
            el.style.height = "auto";
            const endWidth = getComputedStyle(el).height;
            el.style.height = "0px";
            el.offsetHeight;
            el.style.height = endWidth;
        },

        afterEnter(el) {
            el.style.height = "auto";
        },

        beforeLeave(el) {
            el.style.height = getComputedStyle(el).height;
            el.offsetHeight;
            el.style.height = "0px";
        },
    }
}
</script>

<template>
    <Transition name="collapse"
                @after-enter="afterEnter"
                @enter="enter"
                @before-leave="beforeLeave">
        <slot/>
    </Transition>
</template>